import { createContext, useContext } from "react";
import ActivityStore from "./activityStore";
import CommonStore from "./commonStore";
import UserStore from "./userStore";
import ModalStore from "./modalStore";
import { string } from "yup";
import ProfileStore from "./profileStrore";
import CommentSrore from "./commentStore";

interface Store {
    activityStore: ActivityStore;
    commonStore: CommonStore;
    userStore: UserStore; //.
    modalStore: ModalStore;
    profileStore: ProfileStore;
    commentStore: CommentSrore;
}

export const store: Store = {
    activityStore: new ActivityStore(),
    commonStore: new CommonStore(),
    userStore: new UserStore(), //.
    modalStore: new ModalStore(),
    profileStore: new ProfileStore(),
    commentStore: new CommentSrore(),
}

export const StoreContext = createContext(store);

export function useStore() {
    return useContext(StoreContext);
}
